'use strict';

/**
 * AdminUsersController - contrôleur de gestion des utilisateurs
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminUsersController', ['$scope', '$http', function($scope, $http) {
  
  // Initialisation des variables de pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.totalItems = 0;
  $scope.totalPages = 0;
  
  // Génération des données simulées pour le développement
  var mockUsers = [];
  var roles = [
    ['ROLE_USER'],
    ['ROLE_USER', 'ROLE_EDITOR'],
    ['ROLE_USER', 'ROLE_MODERATOR'],
    ['ROLE_USER', 'ROLE_ADMIN']
  ];
  for (var i = 1; i <= 30; i++) {
    mockUsers.push({
      id: i,
      username: 'user' + i,
      email: 'user' + i + '@example.com',
      roles: roles[i % roles.length],
      registrationDate: new Date(2022, i % 12, i % 28 + 1),
      active: i % 5 !== 0, // 1 utilisateur sur 5 est inactif
      profileImage: i % 3 === 0 ? 'assets/images/logo-placeholder.png' : null
    });
  }
  
  // Fonction de recherche et de chargement des utilisateurs
  function loadUsers() {
    $http.get('/api/admin/users?page=' + ($scope.currentPage - 1) + '&size=' + $scope.itemsPerPage)
      .then(function(response) {
        $scope.users = response.data.content;
        $scope.totalItems = response.data.totalElements;
        $scope.totalPages = response.data.totalPages;
      })
      .catch(function() {
        console.error('Erreur lors du chargement des utilisateurs');
        // En mode développement, utiliser les données simulées
        $scope.users = mockUsers.slice(
          ($scope.currentPage - 1) * $scope.itemsPerPage, 
          $scope.currentPage * $scope.itemsPerPage
        );
        $scope.totalItems = mockUsers.length;
        $scope.totalPages = Math.ceil(mockUsers.length / $scope.itemsPerPage);
      });
  }
  
  // Génération des numéros de page pour la pagination
  $scope.getPages = function() {
    var pages = [];
    var startPage = Math.max(1, $scope.currentPage - 2);
    var endPage = Math.min($scope.totalPages, $scope.currentPage + 2);
    
    for (var i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  // Changement de page
  $scope.setPage = function(page) {
    if (page < 1 || page > $scope.totalPages) {
      return;
    }
    $scope.currentPage = page;
    loadUsers();
  };
  
  // Ouvrir la modal pour créer un nouvel utilisateur
  $scope.openNewUserModal = function() {
    alert('Fonctionnalité non implémentée: Création d\'utilisateur');
  };
  
  // Éditer un utilisateur existant
  $scope.editUser = function(user) {
    alert('Fonctionnalité non implémentée: Édition de l\'utilisateur ' + user.username);
  };
  
  // Activer/désactiver un utilisateur
  $scope.toggleUserStatus = function(user) {
    var action = user.active ? 'désactiver' : 'activer';
    
    if (confirm('Êtes-vous sûr de vouloir ' + action + ' l\'utilisateur "' + user.username + '" ?')) {
      $http.put('/api/admin/users/' + user.id + '/toggle-status')
        .then(function() {
          loadUsers();
        })
        .catch(function() {
          console.error('Erreur lors du changement de statut de l\'utilisateur');
          // Simuler le changement en mode développement
          var index = mockUsers.findIndex(function(u) { return u.id === user.id; });
          if (index !== -1) {
            mockUsers[index].active = !mockUsers[index].active;
            loadUsers();
          }
        });
    }
  };
  
  // Chargement initial des utilisateurs
  loadUsers();
}]);
